import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

/** Webapp: solo tema scuro. Il chiaro resta nel codice (classi Tailwind) ma non è selezionabile. */
export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    localStorage.setItem('darkMode', 'true');
    document.documentElement.classList.add('dark');
  }, []);

  return (
    <ThemeContext.Provider value={{ isDark: true }}>
      {children}
    </ThemeContext.Provider>
  );
};
